export default {
  email: 'メールアドレスの形式が正しくありません',
}
